import type { ApiResponse } from '../../types/responses/api-response';

export const extractApiData = <T = any>(response: unknown): T => {
  if (response && typeof response === 'object' && 'data' in response) {
    const wrapped = response as ApiResponse<T>;
    if (wrapped.data !== undefined) {
      return wrapped.data;
    }
  }
  return response as T;
};
